var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCircleProgress25 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    stroke: "#ED6A5A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9C15 8.21207 14.8448 7.43185 14.5433 6.7039C14.2417 5.97595 13.7998 5.31451 13.2426 4.75736C12.6855 4.20021 12.0241 3.75825 11.2961 3.45672C10.5681 3.15519 9.78793 3 9 3L9 9H15Z",
    fill: "#ED6A5A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleProgress25);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;